import { trackAdblock } from 'shared_critical/tracking/shared/special_events';

// Configure the adblock detector
(function(){
  function adBlockDetected() {
    if (!window.sessionStorage.getItem('adBlockDetected')) {
      window.sessionStorage.setItem('adBlockDetected', true);
      MOVE_DATA.adobeDTM.adBlocker = 'true';
      trackAdblock('true');
    }
  }

  if(typeof window.adblockDetector === 'undefined') {
    adBlockDetected();
  } else {
    window.adblockDetector.init(
      {
        debug: false,
        found: function(){
          adBlockDetected();
        }
      }
    );
  }
}());



// WEBPACK FOOTER //
// ./shared_critical/adblock_detector_config.js